import assets from "assets";
import { AutoColumn } from "components/Column";
import { OverviewDataCards } from "components/DataCard";
import { HideMedium, ShowMedium } from "components/Hide";
import QuestionHelper from "components/QuestionHelper";
import Row, { ResponsiveRow, ResponsiveRowWrap } from "components/Row";
import { useTotalNFTSeller } from "data/nft/totalDailyNFTSeller";
import { useTotalNFTMint } from "data/nft/totalNFTMint";
import { useTotalNFTBuyer } from "data/nft/totalNFTbuyer";
import { useMaticPrice } from "data/prices/maticCurrentPrice";
import { useAverageAndMedianPrices } from "data/prices/medianPrices";
import useMatchBreakpoints from "hooks/useMatchBreakpoints";
import { PageWrapper } from "pages/styled";
import React, { useEffect } from "react";
import styled from "styled-components";
import { TEXT } from "theme/texts";
import NFTMarketCapGraph from "./NFTMarketCapGraph";
import TotalNFTCollectionsGraph from "./TotalNFTCollectionsGraph";
import TotalNFTMintsGraph from "./TotalNFTMintsGraph";
import TotalNFTVolumeGraph from "./TotalNFTVolumeGraph";
import TotalNFTWalletsGraph from "./TotalNFTWalletsGraph";
// import { useUniqueOwners } from "data/nft/uniqueOwners";
import { useUniqueNFTOwners } from "data/nft/UniqueNFTOwners";
import { formatAmount } from "utils/numbers";
import Marquee from "components/Marquee";
import { useDailyNFTContractInteractions } from "data/nft/totalDailyContractInteractions";
import { marketOverviewPageElementIDs } from "utils/path";
import { StyledCommonCard } from "components/Card";
import { HorizontalDivider } from "components/Divider/inde";
import { ResponsiveRowReverseByDesktop } from "./styled";
import { useDailyWallet } from "data/nft/dailyWallet";

import { useMaticPrices } from "data/prices/meanAndCurrentPrice";
import { useTopMarketData } from "data/nft/topMarketplace";
import { useHighestNFTSale } from "data/nft/HighestNFTSale";
import { useTopCollectionByTrend } from "data/nft/TopCollectionByTrend";
import { useTopCollectionByVolume } from "data/nft/TopCollectionByVolume";
import { useNFTMints } from "data/nft/nftmints";
import { useNFTBuyers } from "data/nft/dailyNFTBuyers";
import { useNFTSellers } from "data/nft/dailyNFTSellers";

const ResponsiveSubHeader = styled.div`
  width: 100%;
  min-width: 1000px;
  height: 45px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 14px 126px;
  border-bottom: 0.5px solid ${({ theme }) => theme.border2};
  border-top: 0.5px solid ${({ theme }) => theme.border2};
  justify-content: space-around;
  ${({ theme }) => theme.mediaWidth.upToMedium`
      padding: 14px 16px;
  `};
`;

const LogoWrapper = styled.div`
  padding-top: 2px;
  padding-right: 100px;
  ${({ theme }) => theme.mediaWidth.upToMedium`
     padding-right: 6px;
  `}
`;

const Wrapper = styled.div`
  width: 100%;
`;

const WrapperGrid = styled(ResponsiveRowWrap)` {
    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  }`;

export const GraphResponsiveStyledCard = styled(StyledCommonCard)`
   {
    padding: 0rem;
    display: flex;
    flex-direction: column;
    margin-top: 48px;
    box-shadow: 0px 0px 20px 0px rgba(20, 238, 236, 0.5);


  
    ${({ theme }) => theme.mediaWidth.upToMedium`
       margin-top:34px;
  `}
  }
`;

export const ResponsiveGraphHeader = styled(TEXT.MediumHeader)`
   {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    ${({ theme }) => theme.mediaWidth.upToMedium`
      font-size:16px!important;
  `}
  }
`;

export default function MarketOverview() {
  const refNFTMarketGraph: React.RefObject<HTMLElement> =
    React.useRef<HTMLElement>(null);
  const refTotalVolumeGraph: React.RefObject<HTMLElement> =
    React.useRef<HTMLElement>(null);
  const refTotalNFTWalletsGraph: React.RefObject<HTMLElement> =
    React.useRef<HTMLElement>(null);
  const refNFTCollectionsGraph: React.RefObject<HTMLElement> =
    React.useRef<HTMLElement>(null);
  const refNFTMintsGraph: React.RefObject<HTMLElement> =
    React.useRef<HTMLElement>(null);

  useEffect(() => {
    scrollToElement();
  }, []);
  //const executeScroll = (ref: React.RefObject<HTMLElement>) => ref.current?.scrollIntoView({ behavior: 'smooth', block: 'center' })

  // const maticPriceData = useAverageAndMedianPrices();
  // const maticCurrentPrice = useMaticCurrentPrice();
  const uniqueOwners = useUniqueNFTOwners();
  const { isMobile, isTablet, isDesktop } = useMatchBreakpoints();
  const nFTContractInteractions = useDailyNFTContractInteractions();

  const dailyWallet = useDailyWallet();
  const maticPrices = useMaticPrices();
  const { data: dailyNFTMints } = useNFTMints();
  const { data: dailyNFTBuyers } = useNFTBuyers();
  const { data: dailyNFTSellers } = useNFTSellers();
  const reverseDailyNFTMints =
    dailyNFTMints &&
    dailyNFTMints?.records &&
    [...dailyNFTMints?.records]?.reverse();
  const topMarketPlace = useTopMarketData();
  const highestNFTSale = useHighestNFTSale();
  const TopTrendingCollection = useTopCollectionByTrend();

  const TopCollectionByVolume = useTopCollectionByVolume();

  const subheader_data = [
    {
      label: "Mean Matic Price",
      value:
        // maticPriceData !== undefined && maticPriceData.records !== undefined
        //   ? maticPriceData?.records[0]?.avgPriceUsd?.toFixed(2) + " USD"
        //   : "",
        maticPrices && maticPrices?.data && maticPrices?.data?.mean
          ? maticPrices?.data?.mean + " USD"
          : "0",
    },
    {
      label: "Median Matic Price",
      value:
        // maticPriceData !== undefined && maticPriceData.records !== undefined
        //   ? maticPriceData?.records[0]?.medianPriceUsd?.toFixed(2) + " USD"
        //   : "",
        maticPrices && maticPrices?.data && maticPrices?.data?.median
          ? maticPrices?.data?.median + " USD"
          : "0",
    },
    {
      label: "Current Matic Price",
      value:
        // maticCurrentPrice !== undefined &&
        //   maticCurrentPrice.records !== undefined
        //   ? maticCurrentPrice?.records[0]?.currentPrice?.toFixed(2) + "USD"
        //   : "0",
        maticPrices && maticPrices?.data && maticPrices?.data?.current
          ? maticPrices?.data?.current + " USD"
          : "0",
    },
    {
      label: "Unique Owners (>1 NFT)",
      value:
        (uniqueOwners &&
          uniqueOwners?.data &&
          formatAmount(Number(uniqueOwners?.data))) ||
        0,
    },
    {
      label: "Top Marketplace (by volume)",
      value: topMarketPlace?.data?.topMarketPlace || "TBU",
    },
    {
      label: "Highest NFT Sale",
      value:
        (highestNFTSale?.data?.data &&
          highestNFTSale?.data?.data[0]?.name +
            "-" +
            formatAmount(highestNFTSale?.data?.data[0]?.price_in_usd) +
            " USD") ||
        "TBU",
    },
    {
      label: "Top Trending Collection",
      value:
        (TopTrendingCollection?.data?.data &&
          TopTrendingCollection?.data?.data[0]?.name) ||
        "TBU",
    },
    {
      label: "Top Collection by Volume",
      value:
        (TopCollectionByVolume?.data?.data &&
          TopCollectionByVolume?.data?.data[0]?.name) ||
        "TBU",
    },
  ];
  const overviewCardsData = [
    {
      title: "Daily NFT Mints",
      tooltip: "NFTs minted over 24 hours",
      count:
        reverseDailyNFTMints !== undefined
          ? reverseDailyNFTMints[0].daily_mints
          : 0,
      priceChange:
        reverseDailyNFTMints !== undefined
          ? ((reverseDailyNFTMints[1].daily_mints -
              reverseDailyNFTMints[2].daily_mints) *
              100) /
            reverseDailyNFTMints[2].daily_mints
          : 0,
    },
    {
      title: "Daily NFT buyers",
      tooltip: "Wallets that bought an NFT over 24 hours",
      count:
        dailyNFTBuyers !== undefined && dailyNFTBuyers?.value !== undefined
          ? Number(dailyNFTBuyers?.value)
          : 0,
      priceChange:
        dailyNFTBuyers !== undefined && dailyNFTBuyers?.percentage !== undefined
          ? Number(dailyNFTBuyers?.percentage)
          : 0,
    },
    {
      title: "Daily NFT Sellers",
      tooltip: "Wallets that sold an NFT over 24 hours",
      count:
        dailyNFTSellers !== undefined && dailyNFTSellers?.value !== undefined
          ? Number(dailyNFTSellers?.value)
          : 0,
      priceChange:
        dailyNFTSellers !== undefined &&
        dailyNFTSellers?.percentage !== undefined
          ? Number(dailyNFTSellers?.percentage)
          : 0,
    },
    {
      title: "Daily New Wallets",
      tooltip: "Daily new wallets that interacted with NFTs over 24 hours",
      count:
        dailyWallet && dailyWallet?.data?.newWallets
          ? dailyWallet?.data?.newWallets
          : 0,
      priceChange:
        dailyWallet && dailyWallet?.data?.percentage
          ? dailyWallet?.data?.percentage
          : 0,
    },
  ];

  function scrollToElement() {
    let currentLocation = window.location.href;
    const hasElementAnchor = currentLocation.includes("/#");
    if (hasElementAnchor) {
      const anchorElementId = `${currentLocation.substring(
        currentLocation.lastIndexOf("#") + 2
      )}`;
      const anchorComment = document.getElementById(anchorElementId);
      if (anchorComment) {
        anchorComment.scrollIntoView({ behavior: "smooth" });
      }
    }
  }

  return (
    <Wrapper>
      <Marquee data={subheader_data} />
      <PageWrapper>
        <WrapperGrid justifyContent={"space-around"} gap="1.1rem">
          {overviewCardsData.map((value, index) => {
            return (
              <OverviewDataCards
                key={index}
                title={value.title}
                tooltip={value.tooltip}
                count={value.count}
                priceChange={value.priceChange}
              />
            );
          })}
        </WrapperGrid>
        {/* <ThemedBackgroundGlobal backgroundColor={"green"} /> */}

        <AutoColumn gap="16px">
          {/* Total NFT Volume, and Sales Graph*/}
          <GraphResponsiveStyledCard
            id={marketOverviewPageElementIDs.nftVolume}
            ref={refTotalVolumeGraph}
          >
            <TotalNFTVolumeGraph refTotalVolumeGraph={refTotalVolumeGraph} />
          </GraphResponsiveStyledCard>
          {/* Total NFT Mint Graph*/}
          <GraphResponsiveStyledCard
            id={marketOverviewPageElementIDs.nftMints}
            ref={refNFTMintsGraph}
          >
            <TotalNFTMintsGraph refNFTMintsGraph={refNFTMintsGraph} />
          </GraphResponsiveStyledCard>
          {/* Total NFT Wallets Graph*/}
          <GraphResponsiveStyledCard
            id={marketOverviewPageElementIDs.nftWallets}
            ref={refTotalNFTWalletsGraph}
          >
            <TotalNFTWalletsGraph
              refTotalNFTWalletsGraph={refTotalNFTWalletsGraph}
            />
          </GraphResponsiveStyledCard>
          {/* Total NFT Collections & NFT Market Cap Graph */}
          <ResponsiveRowReverseByDesktop width={"100%"} gap="26px">
            <GraphResponsiveStyledCard
              id={marketOverviewPageElementIDs.nftCollections}
              ref={refNFTCollectionsGraph}
            >
              <TotalNFTCollectionsGraph
                refNFTCollectionsGraph={refNFTCollectionsGraph}
              />
            </GraphResponsiveStyledCard>
            <GraphResponsiveStyledCard
              id={marketOverviewPageElementIDs.nftMarketCap}
              ref={refNFTMarketGraph}
            >
              <NFTMarketCapGraph refNFTMarketGraph={refNFTMarketGraph} />
            </GraphResponsiveStyledCard>
          </ResponsiveRowReverseByDesktop>
        </AutoColumn>
      </PageWrapper>
    </Wrapper>
  );
}
